var map = {
	"./README.md": 5794,
	"./en/help/about_dezrann.md": 8654,
	"./en/help/dev_doc.md": 8508,
	"./en/help/first_steps.md": 8844,
	"./en/help/label_templates.md": 3340,
	"./en/help/labels_and_analyzes.md": 2913,
	"./en/help/new_piece.md": 1565,
	"./en/help/views.md": 1372,
	"./fr/help/about_dezrann.md": 947,
	"./fr/help/first_steps.md": 2421,
	"./fr/help/label_templates.md": 3953,
	"./fr/help/labels_and_analyzes.md": 6700,
	"./fr/help/new_piece.md": 2676,
	"./fr/help/views.md": 5441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5446;